export default __webpack_public_path__ + "static/banner-the-worlds-most-luxurious-cars-2754b7fd99da8aba99f063c85d3b2f57.jpg";